import { ItemDateLocation, Badge } from '@sbt-web/ui';
import classnames from 'classnames';
import React from 'react';
import css from './PostingTimeAndPlace.module.scss.js';

const VetrinaBadge = ({ active, }) => {
    return active ? (React.createElement(Badge, { themed: true, classes: [css['vetrina-badge']] }, "Vetrina")) : null;
};
const UrgenteBadge = ({ active, urgentLabelOverride = 'Urgente' }) => {
    return active ? (React.createElement(Badge, { themed: true, inverted: true, classes: [css['urgent-badge']] }, urgentLabelOverride)) : null;
};
const PostingTimeAndPlace = ({ date, cityShortName, town = '', gallerized, urgent = false, classes, urgentLabelOverride, }) => (React.createElement("div", { className: classnames(css['posting-time-place'], { [css['with-badge']]: gallerized || urgent }, classes) },
    React.createElement(VetrinaBadge, { active: gallerized }),
    React.createElement(UrgenteBadge, { active: urgent, urgentLabelOverride: urgentLabelOverride }),
    React.createElement(ItemDateLocation, { className: css['date-location'], date: date, cityShortName: cityShortName, town: town, gallerized: gallerized || urgent })));
PostingTimeAndPlace.displayName = 'PostingTimeAndPlace';

export { PostingTimeAndPlace as default };
//# sourceMappingURL=PostingTimeAndPlace.js.map
